import FilterAccordion from './FilterAccordion';
import MuiCheckboxChip from '../mui-components/MuiCheckboxChip';
import MuiRadioChip from '../mui-components/MuiRadioChip';
import { Body3 } from '../../themes/typography';

export default function EventFilter({
    filterState = {},
    setFilterState = () => { },
    eventFilterConfig = []
}) {

    return (
        <div className="event-filter-criteria-area">
            <div className="event-filter-criteria-options">
                {eventFilterConfig.map(({
                    id,
                    label,
                    type,
                    options,
                    shouldShowToolTip,
                    tooltipText
                }, index) => {
                    const selectedValue = filterState[id];
                    const selectedCount =
                        type === 'checkbox'
                            ? (selectedValue?.length || 0)
                            : selectedValue
                                ? 1
                                : 0;

                    return (
                        <FilterAccordion
                            key={id}
                            label={label}
                            defaultExpanded={index === 0}
                            activeCount={selectedCount}
                        >
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>

                                {shouldShowToolTip && options.length > 0 && <Body3>{tooltipText}</Body3>}

                                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.75rem' }}>
                                    {type === 'checkbox' && (
                                        <MuiCheckboxChip
                                            checkboxOptions={options}
                                            selectedCheckbox={filterState[id] || []}
                                            setSelectedCheckbox={(updater) =>
                                                setFilterState(prev => {
                                                    const prevArr = Array.isArray(prev[id]) ? prev[id] : [];
                                                    const nextVal = typeof updater === 'function' ? updater(prevArr) : updater;
                                                    return { ...prev, [id]: nextVal };
                                                })
                                            }
                                        />
                                    )}

                                    {type === 'radio' && (
                                        <MuiRadioChip
                                            radioOptions={options}
                                            selectedRadioValue={id === 'sortBy' && !filterState[id] ? options[0] : (filterState[id] || {})}
                                            setSelectRadioValue={(val) =>
                                                setFilterState((prev) => ({ ...prev, [id]: val }))
                                            }
                                        />
                                    )}
                                </div>

                            </div>
                        </FilterAccordion>
                    )
                })}
            </div>
        </div>
    );
}